<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/stores/app'
import HomePage from './HomePage.vue'
import Dashboard from '@/pages/Dashboard/index.vue'

const appStore = useAppStore()
const authInitialized = computed(() => appStore.authInitialized)
const isLoggedIn = computed(() => appStore.isLoggedIn)
</script>

<template>
  <template v-if="authInitialized">
    <HomePage v-if="!isLoggedIn" />
    <Dashboard v-else />
  </template>
</template>
